import { render, staticRenderFns } from "./Statistic-query.vue?vue&type=template&id=4da5678e&"
import script from "./Statistic-query.vue?vue&type=script&lang=js&"
export * from "./Statistic-query.vue?vue&type=script&lang=js&"
import style0 from "./Statistic-query.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports